import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCritical = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "25px",
	height: "25px",
	viewBox: "0 0 25 25",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("path", {
			d: "M16.2519,3.9999 C17.3139,3.9999 18.3029,4.6159 18.7709,5.5689 L18.7709,5.5689 L28.2429,24.8669 C28.6309,25.6519 28.5849,26.5679 28.1199,27.3129 C27.6579,28.0559 26.8579,28.4999 25.9799,28.4999 L25.9799,28.4999 L6.5239,28.4999 C5.6479,28.4999 4.8469,28.0559 4.3829,27.3129 C3.9199,26.5679 3.8739,25.6529 4.2609,24.8659 L4.2609,24.8659 L13.7339,5.5689 C14.2019,4.6159 15.1899,3.9999 16.2519,3.9999 Z M16.2519,5.9999 C15.9469,5.9999 15.6629,6.1769 15.5279,6.4509 L15.5279,6.4509 L6.0559,25.7479 C5.9759,25.9119 5.9849,26.1009 6.0809,26.2549 C6.1759,26.4079 6.3419,26.4999 6.5239,26.4999 L6.5239,26.4999 L25.9799,26.4999 C26.1609,26.4999 26.3269,26.4079 26.4219,26.2559 C26.5189,26.1009 26.5279,25.9119 26.4479,25.7499 L26.4479,25.7499 L16.9759,6.4499 C16.8409,6.1769 16.5569,5.9999 16.2519,5.9999 Z M16.252,22 C17.01,22 17.627,22.617 17.627,23.375 C17.627,24.133 17.01,24.75 16.252,24.75 C15.494,24.75 14.877,24.133 14.877,23.375 C14.877,22.617 15.494,22 16.252,22 Z M16.252,11.5 C16.7645714,11.5 17.1874694,11.8862857 17.2452682,12.3834315 L17.252,12.5 L17.252,20 C17.252,20.553 16.804,21 16.252,21 C15.7394286,21 15.3165306,20.6145765 15.2587318,20.1167533 L15.252,20 L15.252,12.5 C15.252,11.948 15.7,11.5 16.252,11.5 Z",
			id: "path-1"
		}) }),
		/* @__PURE__ */ _jsx("g", {
			id: "Styleboard",
			stroke: "none",
			strokeWidth: 1,
			fill: "none",
			fillRule: "evenodd",
			children: /* @__PURE__ */ _jsx("g", {
				id: "EDUbadges_styleboard",
				transform: "translate(-628.000000, -7253.000000)",
				children: /* @__PURE__ */ _jsx("g", {
					id: "notifications",
					transform: "translate(460.000000, 6372.000000)",
					children: /* @__PURE__ */ _jsx("g", {
						id: "info-components-/-notification-/-05-critical",
						transform: "translate(152.000000, 870.000000)",
						children: /* @__PURE__ */ _jsxs("g", {
							id: "basis-/-check-3px-copy",
							transform: "translate(12.000000, 7.000000)",
							children: [
								/* @__PURE__ */ _jsx("polygon", {
									id: "Path-2",
									fill: "#FFFFFF",
									points: "5 25.4447139 15.429494 5 17.0640283 5 27.0299137 25.4447139 26.3139521 27.0889186 5.81381281 27.0889186"
								}),
								/* @__PURE__ */ _jsx("mask", {
									id: "mask-2",
									fill: "white",
									children: /* @__PURE__ */ _jsx("use", { xlinkHref: "#path-1" })
								}),
								/* @__PURE__ */ _jsx("use", {
									id: "Combined-Shape",
									fill: "#000000",
									xlinkHref: "#path-1"
								}),
								/* @__PURE__ */ _jsx("g", {
									id: "Group",
									mask: "url(#mask-2)",
									children: /* @__PURE__ */ _jsxs("g", {
										id: "\\uD83C\\uDFA8-Color",
										children: [/* @__PURE__ */ _jsx("rect", {
											id: "Rectangle",
											fill: "#FFFFFF",
											x: 0,
											y: 0,
											width: 32,
											height: 32
										}), /* @__PURE__ */ _jsx("g", {
											id: "Colors/Gray-900-Copy",
											fill: "#FF0000",
											children: /* @__PURE__ */ _jsx("path", {
												d: "M0,0 L32,0 L32,32 L0,32 L0,0 Z",
												id: "Colors/Red-900"
											})
										})]
									})
								})
							]
						})
					})
				})
			})
		})
	]
});
const ForwardRef = forwardRef(SvgCritical);
export default ForwardRef;
